<script lang="ts">
import {BuildingOutline} from "flowbite-svelte-icons";

    export let title: string = 'Modal';
</script>

<h3 class="text-xl font-semibold text-neutral-600 dark:text-white pl-4 flex items-center">
    <BuildingOutline class="mr-2 w-4"/>
    <slot>
        <span>{title}</span>
    </slot>
</h3>